import NavItem from "@/ui/atoms/NavItem"
import Typography from "@/ui/atoms/Typography"
import Container from "@/ui/structure/Container"
import { LinkData } from "@/ui/types/link"
import { NavItemData } from "@/ui/types/nav"
import { ReactNode } from "react"

export type FooterCompanyColumn = {
  logo: ReactNode
  address?: ReactNode
  email?: string
}

export type FooterSocialLink = {
  logo: ReactNode
  link: LinkData
}

export type FooterLinksColumn = {
  level1links?: NavItemData[]
  level2links?: NavItemData[]
  socialLinks?: FooterSocialLink[]
  copyright?: ReactNode
}

export interface FooterProps {
  company: FooterCompanyColumn
  links: FooterLinksColumn
}

const Footer = ({ company, links }: FooterProps) => {
  return (
    <footer className="relative bg-negative-contrast text-negative">
      <Container className="py-8 xl:pt-24">
        <div className="flex flex-col gap-16 xl:flex-row xl:justify-between">
          <div>{company.logo}</div>
          {links.level1links && (
            <div
              className={
                "flex flex-col gap-8 xl:flex-row xl:flex-wrap xl:justify-end xl:items-end"
              }
            >
              {links.level1links?.map((item, i) => (
                <NavItem link={item.link?.url} key={i}>
                  <Typography variant={"body1"} sameHeight>
                    {item.label}
                  </Typography>
                </NavItem>
              ))}
            </div>
          )}
        </div>
        <div className="my-12 xl:my-16 border-b-[1px] border-secondary"></div>
        <div className="flex flex-col justify-between gap-16 xl:flex-row">
          <div className="flex flex-col gap-8 xl:gap-16 xl:flex-row">
            {links.socialLinks &&
              links.socialLinks.map((x, i) => (
                <div key={i} className="h-[70px]">
                  <a href={x.link?.url} target="_blank" rel="noreferrer">
                    {x.logo}
                  </a>
                </div>
              ))}
          </div>
          <div className="xl:flex xl:items-end">
            <div
              className={
                "flex flex-col gap-8 xl:flex-row xl:flex-wrap xl:justify-end xl:items-end"
              }
            >
              {links.level2links?.map((item, i) => (
                <NavItem link={item.link?.url} key={i}>
                  <Typography variant={"body1"} sameHeight>
                    {item.label}
                  </Typography>
                </NavItem>
              ))}
            </div>
          </div>
        </div>
        <div className="xl:flex xl:justify-between mt-16 xl:text-right">
          <Typography variant={"body1"}>{links.copyright}</Typography>

          <Typography variant={"body1"} className="my-4">
            {company.address}
          </Typography>
        </div>
      </Container>
    </footer>
  )
}

export default Footer
